import styled from 'styled-components';

export const InfoBlockTitle = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  color: var(--color-text-muted);
  padding: 0 0 10px;
`;
